import React, { Component } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import afsp from './images/afsp.png';
import bethere from './images/bethere.jpg';
import thedisruptiveacademy from './images/thedisruptiveacademy.png';
import twloha from './images/twloha.png';
import './css/Partners.css';

class Landing extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <div className="App-content">
          <div className="separator"></div>
          <div className="partner-head">OUR PARTNERS</div>
          
          <div className="separator"></div>

          <div className="partner-group">
            <div className="partner">
              <a href="https://twloha.com/" rel="noopener noreferrer" target="_blank"><img src={twloha} alt="partners" /></a>
            </div>
            <div className="partner">
              <a href="https://www.facebook.com/illbethereproject" rel="noopener noreferrer" target="_blank"><img src={bethere} alt="partners" /></a>
            </div>
          </div>
          <div className="partner-group">
            <div className="partner">
              <a href="https://afsp.org" rel="noopener noreferrer" target="_blank"><img src={afsp} alt="partners" /></a>
            </div>
            <div className="partner">
              <a href="https://thedisruptiveacademy.com/freetrial" rel="noopener noreferrer" target="_blank"><img src={thedisruptiveacademy} alt="partners" /></a>
            </div>
          </div>

          <div className="separator"></div>

        </div>

        <Footer />

      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/Partners.js